import { render, staticRenderFns } from "./ChildMessageItem.vue?vue&type=template&id=8df184de"
import script from "./ChildMessageItem.vue?vue&type=script&lang=js"
export * from "./ChildMessageItem.vue?vue&type=script&lang=js"
import style0 from "./ChildMessageItem.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports